/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconHeadphones({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 256 256" className={className} {...props} {...attrs} data-test="IconHeadphones">  <path fill="currentColor" d="M218.79 128.32c0-48.3-40.68-87.6-90.69-87.6A91.72 91.72 0 0064 66.38a85.39 85.39 0 00-26.6 61.83c0 1.53-1.16 37.66-1.16 41.35 0 29.51 23 53.53 51.2 53.53a15.24 15.24 0 0015.4-15.4v-76.46a15.23 15.23 0 00-15.4-15.4 48.26 48.26 0 00-21.07 4.91C70.32 91.46 96.76 69 128.1 69s57.83 22.52 61.73 51.86a49.33 49.33 0 00-21.27-4.86 15.24 15.24 0 00-15.4 15.4v76.46a15.23 15.23 0 0015.4 15.4c28.23 0 51.2-24 51.2-53.53 0-3.67-.96-41.08-.97-41.41z" /></svg>
  );
}

IconHeadphones.propTypes = iconPropTypes;
IconHeadphones.defaultProps = iconDefaultProps;
